import moment from "moment";

export class BookingNote {
  constructor(userId, message) {
    this.message = message;
    this.created = moment.utc().toJSON();
    this.createdBy = userId;
  }

  isValid() {
    const userIdEmpty =
      !!this.userId && !!this.name.trim();
    const messageEmpty =
      !!this.message && !!this.message.trim();
    return userIdEmpty && messageEmpty;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    return Object.assign(new BookingNote(), json);
  }
}
